import React from 'react';
import { Grid, Text } from 'elements';
import Card from 'components/case/parts/Card';
import { sampleCaseNoteHitCount } from 'libs/api/case';
import { TCaseExplain } from 'modules/case/types';
import { CWindowWidth } from 'constants/base.const';
import { Button } from 'antd';

interface IStepExplain {
  explains: Array<TCaseExplain>;
  onClick: (args1: number) => void;
}

const StepExplain = ({ explains, onClick }: IStepExplain) => {
  const setRate = (explain: TCaseExplain) => {
    return Array.isArray(explain.ratings) && explain.ratings[0] ? Number(explain.ratings[0]) : 0;
  };

  const setRateText = (explain: TCaseExplain) => {
    return Array.isArray(explain.ratings) && explain.ratings[1] ? `“${explain.ratings[1]}“` : '';
  };

  //샘플 노트 조회수 카운트
  const hitCount = async () => {
    const { success, data } = await sampleCaseNoteHitCount();
  };

  return (
    <Grid
      maxWidth={`${CWindowWidth}px`}
      padding='50px 50px'
      md={{ padding: '50px 20px' }}
      sm={{ padding: '16px' }}
    >
      <Grid gap='50px' align='center' sm={{ justify: 'space-between', padding: '0 5px' }}>
        <Text size='2rem'>Career Step 해설</Text>
        <Button
          className='small outline'
          onClick={() => {
            window.open('/sample.pdf');
            hitCount();
          }}
        >
          샘플 보기
        </Button>
      </Grid>

      <Grid>
        <Text size='1.1rem'>
          Career Step의 case 전문 멘토진이 실전 인터뷰 상황처럼 작성한 해설. 어디에서도 볼 수 없던 생생한 full
          script 로 만나보세요.
        </Text>
      </Grid>
      <Grid
        marginTop='35px'
        justify={explains.length < 3 ? 'flex-start' : 'space-between'}
        gap='35px'
        sm={{ marginTop: '10px', padding: '0 5px' }}
      >
        {explains.length === 0 ? (
          <Grid justify='center' align='center' height='100px'>
            <Text size='1.2rem'>데이터가 없습니다.</Text>
          </Grid>
        ) : (
          explains.map((explain) => (
            <Grid key={explain.id} isInline width='30%' md={{ width: '100%', justify: 'center' }}>
              <Card
                name={explain.name}
                subTitle={explain.mentor.short_introduction ? `“${explain.mentor.short_introduction}”` : ''}
                thumbnail={explain.mentor.profile_image}
                thumbnailTitle={explain.mentor.is_current}
                isPurchase={explain.is_payed}
                rateCount={explain.rating_count}
                rate={setRate(explain)}
                rateTitle={setRateText(explain)}
                career={
                  <Grid align='flex-end'>
                    {!!explain.mentor.company && (
                      <Grid justify='space-between'>
                        <Text>{explain.mentor.company}</Text>
                        <Text>{explain.mentor.duration} 근무</Text>
                      </Grid>
                    )}
                    {explain.mentor.university && explain.mentor.major && (
                      <Grid>
                        <Text>
                          {explain.mentor.university} {explain.mentor.major} 졸업
                        </Text>
                      </Grid>
                    )}
                  </Grid>
                }
                questions={explain.key_question}
                onClick={() => onClick(explain.id)}
              />
            </Grid>
          ))
        )}
      </Grid>
    </Grid>
  );
};

export default StepExplain;
